function isToday(d) {
    const now = new Date();
    return now.getDate() === d.getDate() && now.getMonth() === d.getMonth() && now.getFullYear() == d.getFullYear()
}

export default function calendar(year, month, el, onDateClicked) {
    const d = new Date(year, month - 1);
    const dayMarker = el("div", { class: "day-marker" }, [
        el("div", "SUN"),
        el("div", "MON"),
        el("div", "TUE"),
        el("div", "WED"),
        el("div", "THU"),
        el("div", "FRI"),
        el("div", "SAT"),
    ]);

    const calendarBody = [];

    for(let i = 0; i < d.getDay(); i++) {
        calendarBody.push(el("div"));
    }

    while(d.getMonth() == month - 1) {
        const dateItem = el("div", {
            class: "date-tile",
            "data-year": d.getFullYear(),
            "data-month": d.getMonth() + 1,
            "data-dom": d.getDate(),
        }, [
            el("div", { class: isToday(d) ? "today" : "" }, `${d.getDate()}`),
            el("div", { ref: `cal-${d.getDate()}`, class: "reservation" }),
        ]);
        dateItem.addEventListener("click", onDateClicked);
        calendarBody.push(dateItem);
        d.setDate(d.getDate() + 1);
    }

    if(d.getDay() !== 0) {
        for(let i = d.getDay(); i < 7; i++) {
            calendarBody.push(el("div"));
        }
    }

    const calendarElem = el("div", { class: "calendar", ref: "calendar" }, [
        dayMarker,
        el("div", { class: "calendar-body", ref: "calendarBody" }, calendarBody),
    ]);

    return calendarElem;
}
